export default __webpack_public_path__ + "resources/icons/d340-ca2a.png";